import React from 'react';

const SvgAl = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="AL_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="AL_svg__b" fill="#fff">
        <use xlinkHref="#AL_svg__a" />
      </mask>
      <path fill="#EE343C" mask="url(#AL_svg__b)" d="M0 0h28v20H0z" />
      <path
        d="M12.474 4.474c-.262-.262-.72-.31-1.02-.11l-.907.605c-.302.201-.282.497.045.66l1.483.742c.327.163.592.592.592.962A.665.665 0 0 1 12 8a3.34 3.34 0 0 1-1.258-.296l-1.484-.741c-.326-.164-.8-.088-1.058.17l-.4.4c-.258.258-.201.6.125.763l1.483.741c.327.164.347.46.045.66l-.906.605c-.302.202-.263.422.112.496l2.016.404c.363.072.412.316.119.536l-1.588 1.19c-.298.224-.243.405.127.405.369 0 .952-.071 1.313-.161l1.375-.344c.357-.09.482.084.281.385l-.604.907c-.202.302-.07.547.301.547h.668a.98.98 0 0 1 .877.632l.245.735c.117.35.304.355.422 0l.245-.735a.983.983 0 0 1 .877-.632H16c.368 0 .502-.246.301-.547l-.604-.907c-.202-.302-.08-.475.28-.385l1.376.344c.357.09.942.161 1.313.161.368 0 .42-.184.127-.404l-1.588-1.19c-.298-.224-.255-.463.12-.537l2.015-.404c.364-.072.414-.295.112-.496l-.906-.604c-.302-.202-.282-.497.045-.66l1.483-.742c.327-.164.383-.504.125-.762l-.4-.401c-.258-.258-.732-.334-1.058-.17l-1.484.741A3.326 3.326 0 0 1 16 8a.665.665 0 0 1-.667-.667c0-.368.272-.802.603-.968L18 5.333l-1.453-.969c-.302-.2-.761-.15-1.021.11l-1.052 1.052a.672.672 0 0 1-.948 0l-1.052-1.052z"
        fill="#262626"
        mask="url(#AL_svg__b)"
      />
    </g>
  </svg>
);

export default SvgAl;
